<template>
  <div class="details">
    <!-- <code> {{ carts }}</code> -->
    <!-- Modal content-->
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-5 col-xs-12">
        <img v-bind:src="fileUrl + 'uploads/products/' + featured_image" class="img-responsive fimage" />
        <div>
          <span class="simg" v-if="product.gp_image_1">
            <img @click="galleryImg(product.gp_image_1)" v-bind:src="fileUrl + 'uploads/products/' + product.gp_image_1"
              class="img-responsive" />
          </span>
          <span class="simg" v-if="product.gp_image_2">
            <img @click="galleryImg(product.gp_image_2)" v-bind:src="fileUrl + 'uploads/products/' + product.gp_image_2"
              class="img-responsive" />
          </span>
          <span class="simg" v-if="product.gp_image_3">
            <img @click="galleryImg(product.gp_image_3)" v-bind:src="fileUrl + 'uploads/products/' + product.gp_image_3"
              class="img-responsive" />
          </span>
          <span class="simg" v-if="product.gp_image_4">
            <img @click="galleryImg(product.gp_image_4)" v-bind:src="fileUrl + 'uploads/products/' + product.gp_image_4"
              class="img-responsive" />
          </span>
        </div>
          </div>

          <div class="col-md-7 col-xs-12">
        <h3 class="ptitle" v-if="globalLanguage == 'EN'">{{ product.name }}</h3>
        <h3 class="ptitle" v-else>{{ product.name_bn }}</h3>
        <div class="code">
          Code: <span class="">#{{ product.id }}</span>
        </div>
        <div>
          Quantity:
          <span class="">{{ product.unit_quantity }}{{ product.unit }}</span>
        </div>
        <div>
          Availability:
          <span class="base-color" style="text-transform: uppercase;font-size: 12px;font-weight: 600;"
            v-if="product.stock_quantity > 0">In Stock</span>
          <span style="text-transform: uppercase;color: red;font-size: 12px;font-weight: 600;" v-else>Out of
            Stock</span>
        </div>
        <div class="price mt10">
          <span class="running" style="font-weight: 500;">{{ product.price - product.discount }} &#8364;</span>
          <br />
          <span class="discounted" v-if="product.discount"><span>{{ product.discount }} </span> &#8364;</span>
        </div>
        <div class="clearfix">
          <div class="p_quantity">
            <span class="plminus btn" @click="decrement(product.id)">-</span>
            <span class="qty">{{ quantity }}</span>
            <span class="plminus btn" @click="increment(product.id)"> +</span>
          </div>
        </div>
        <br />
        <div href="" class="btn btn-success btn-sm btn-add-to-cart" style="border-radius: 3px;width:150px;">
          <img src="@/assets/images/icons/bag-plus-white.png" height="25px" />
          <span @click="createCarts(product.id)"
            style="position: relative;top: 3px;padding-left: 5px;font-size: 13px;">Add to Bag</span>
        </div>
        <ul class="nav nav-tabs mt30" v-if="product.description">
          <li class="active">
            <a data-toggle="tab" href="#Description">Description</a>
          </li>
        </ul>

        <div class="tab-content" v-if="product.description">
          <div id="Description" class="tab-pane fade in active">
            <p v-html="product.description"></p>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
            <CartData
        :carts="carts"
        :sum-cart-total="sum_cart_total || 0"
        :file-url="fileUrl"
        :global-language="globalLanguage"
        @remove-cart-item="removeCartItem"
        @cart-increment="cartIncrement"
        @cart-decrement="cartDecrement"
      />
    <div class="mobilemenu">
      <div class="same">
        <a href="/" class="icon-bottom">
          <img src="@/assets/images/icons/home-ash.png" width="31px" />
        </a>
      </div>
      <div class="gocheckout" v-if="carts.length > 0">
        <router-link to="/cart">
          GO CHECKOUT
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span>
          START SHOPPING
        </span>
      </div>
      <div class="mybag same carts">
        <span>
          <span class="badge">0</span>
          <img class="iconbag" src="@/assets/images/icons/bag.png" alt="Shopping-bag" height="31px" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
const $ = require("jquery");
window.$ = $;
$(function() {
  $(window).scroll(function() {
    $("nav").toggleClass("scrolled", $(this).scrollTop() > 50);
  });
});
import axios from "axios";
import CartData from "./CartData";
export default {
  components: { CartData },
  data() {
    return {
      product: null,
      quantity: 1,
      featured_image: null,
      menuStatus: true,
      carts: [],
      sum_cart_total: 0
    };
  },
  created: function() {
    this.loadApiData();
  },
  mounted() {
    let vm = this;
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
    } else {
      vm.carts = [];
    }
  },
  methods: {
    loadApiData: function() {
      let vm = this;
      vm.$parent.startLoading();
      axios
        .get(this.globalUrl + "product/" + this.$route.params.slug)
        .then(function(response) {
          console.log(response.data);
          vm.product = response.data.data;
          vm.featured_image = response.data.data.featured_image;
        })
        .catch(response => {
          vm.$toasted.show("Something wrong  Try again.", {
            type: "error",
            icon: "fa-exclamation-triangle",
             position: "top-right"
          });
        });
    },
    increment(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex != -1) {
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if (this.quantity < stock_quantity) {
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          this.quantity = newQuantity;
          this.$toasted.show("Product quantity Increment by 1.", {
            type: "success",
            icon: "fa-check-circle",
           position: "top-right"
          });
          this.calculateCartTotal();
        }
      } else {
        let stock_quantity = this.product.stock_quantity;
        if (this.quantity < stock_quantity) {
          this.quantity++;
        } else {
          this.quantity;
        }
      }
    },
    decrement(product_id) {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
        let objIndex = this.carts.findIndex(
          obj => obj.product_id == product_id
        );
        if (objIndex != -1) {
          let oldQuantity = this.carts[objIndex].cart_quantity;
          if (oldQuantity > 1) {
            let newQuantity = oldQuantity - 1;
            let price = this.carts[objIndex].price;
            this.carts[objIndex].cart_quantity = newQuantity;
            this.carts[objIndex].subtotal = price * newQuantity;
            localStorage.setItem("carts", JSON.stringify(this.carts));
            this.carts = JSON.parse(localStorage.getItem("carts"));
            this.$toasted.show("Product quantity Decrement by 1.", {
              type: "success",
              icon: "fa-check-circle",
              position: "top-right"
            });
            this.calculateCartTotal();
          }
        }
      }
    },
    createCarts: function(product_id) {
      let vm = this;
      let thisProductID = product_id;

      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === product_id
      );
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show("Already Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
           position: "top-right"
        });
      } else {
        //console.log(this.products[index].id);
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = this.product.price - this.product.discount;
        result.unshift({
          product_id: this.product.id,
          product_name: this.product.name,
          product_name_bn: this.product.name_bn,
          product_image: this.product.featured_image,
          price: price,
          image: this.product.featured_image,
          quantity: this.product.unit_quantity,
          unit: this.product.unit,
          cart_quantity: this.quantity,
          stock_quantity: this.product.stock_quantity,
          subtotal: price * this.quantity
        });
        console.log(result);
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        vm.$toasted.show("New Product Added In your Bag.", {
          type: "success",
          icon: "fa-check-circle",
          position: "top-right"
        });
        this.calculateCartTotal();
        $(".carts .badge").text(vm.carts.length);
        $(".carts").addClass("animated zoomIn");
        $(".cart_amount").addClass("shadow-pulse");
        setTimeout(function() {
          $(".carts").removeClass("animated zoomIn");
          $(".cart_amount").removeClass("shadow-pulse");
        }, 5000);
      }
    },
    removeCartItem: function(product_id) {
      //alert(product_id);
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      $("#" + product_id).removeClass("cartAdded");
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    cartIncrement(product_id) {
      //alert(product_id);
      let vm = this;
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if (oldQuantity < stock_quantity) {
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $("#" + product_id + " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#" + product_id).addClass("animated");
        setTimeout(function() {
          $("#" + product_id).removeClass("animated");
        }, 500);
      } else {
        vm.$toasted.show(
          "<span>" +
            stock_quantity +
            "</span>" +
            "Quantity is available, Please call for more Quantity.",
          {}
        );
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#" + product_id + " .amountQuantity").text(newQuantity);
        $("#" + product_id).addClass("animated");
        setTimeout(function() {
          $("#" + product_id).removeClass("animated");
        }, 500);
      } else if (oldQuantity == 1) {
        this.carts = this.carts.filter(e => e.product_id !== product_id);
        $("#" + product_id).removeClass("cartAdded");
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      }
    },
    toogleNav: function() {
      $(".small-device #sidebar-area").toggleClass("show");
      $("#content-area").toggleClass("fullwidth");
      $("#sidebar-area").toggleClass("hidden-sidebar");
      $(".cart-data ").removeClass("show");
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    galleryImg: function(image_url) {
      let vm = this;
      vm.featured_image = image_url;
    }
  }
};
</script>
